import { observer } from 'mobx-react-lite';
import { useEffect } from 'react';
import { RoutePaths } from 'src/core/router/RoutePaths';
import { Router } from 'src/core/router/Router';
import { RouterStore } from 'src/stores/RouterStore/RouterStore';

export const IndexPage = observer(() => {
    useEffect(() => {
        // Land on the first section the current user can actually reach, so
        // roles without loan-application access (e.g. FinancialOfficer, who
        // only has the transactions module) don't hit the "Not access" page.
        const [firstAvailable] = RouterStore.menuItems;
        const target =
            firstAvailable?.menuLink ??
            firstAvailable?.path ??
            RoutePaths.loanApplications;

        Router.replace(target);
    }, []);

    return null;
});
